import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { deliveryPageData, deliveryFAQs } from "./deliverydata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForDeliveryManagement() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="Delivery Management Software — AI-Powered Last-Mile Logistics"
        description="EkkBaz AI Delivery Management reduces fuel costs by 30%, achieves 98%+ on-time delivery rates, and eliminates manual dispatch — with real-time tracking, AI route optimisation, and live customer notifications."
        keywords="delivery management software, last mile delivery AI, route optimization software, delivery tracking, fleet management AI, on-time delivery"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/delivery`}
        productName="Delivery Management"
        faqItems={deliveryFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Delivery Management"
        subtitle="AI-optimised routes, intelligent driver dispatch, and real-time tracking — cutting delivery costs by 30% and achieving 98%+ on-time performance."
        from="delivery"
      />
      <EnhancedPageLayout {...deliveryPageData} />
      <UpdateFooter />
    </div>
  );
}
